import Home from '../Home/Home';

const Philanthropic = () => {
  return (
    <Home>
      <div className="container">
        <h1 className="about_us_title">UDAAN’s Philanthropic Profile</h1>
        <p style={{ marginTop: "50px" }}><b>UDAAN</b> has been a beacon of hope and service, dedicated to uplifting underprivileged communities through impactful philanthropic efforts. With a mission rooted in compassion and equity, the organization focuses on providing access to bare necessities at times of need.</p>
        <p>This organization has donated significantly to Delaware Food Bank during covid-pandemic to provide meals to the most affected families in lockdown stricken metropolitan areas like Wilmington, DE.</p>
        <p>It has also sent relief to Amphan cyclone affected regions in South East Asia back in 2020 covering vast remote areas and supported small-scale farmers with training and tools. Their disaster relief initiatives have provided rapid assistance to families affected by natural calamities, delivering essential supplies and emotional support.</p>
        <p>Beyond material support, UDAAN champions community empowerment by sponsoring Bengali cultural artists to perform remotely at various Durga Puja events organized in USA during the lockdown period in the last pandemic.</p>
        <p>Driven by the belief that lasting change begins at the grassroots, the organization continues to expand its reach, fostering resilience and dignity among those it serves.</p>
      </div>
    </Home>
  );
};

export default Philanthropic;
